<script setup lang="ts">
    import { ref } from 'vue';
    import { formatAmount, formatDateFrench } from '@/utils';
    import { useRoute } from 'vue-router';
    import FinancePrelevementsWallet from './@components/FinancePrelevementsWalletComponent.vue';
    import FinancePrelevementsForm from './@forms/FinancePrelevementsForm.vue';
    import ConfirmationModal from '@/components/ConfirmationModal.vue';
    import axios from 'axios';
    import FinancePrelevementsDecaissementsComponent from '@/components/FinancePrelevementsDecaissementsComponent.vue';
    
    const route = useRoute();
    const startup_infos: any = route.meta.startup_infos;
    const collectivite: any = startup_infos.collectivite;
    const financePrelevementsWalletRef = ref<InstanceType<typeof FinancePrelevementsWallet> | null>(null);
    const financePrelevementsDecaissementsRef = ref<InstanceType<typeof FinancePrelevementsDecaissementsComponent> | null>(null);
    const confirmationModalRef = ref<InstanceType<typeof ConfirmationModal> | null>(null);
    const loadingSendInvitations = ref(false);
    const errorMessageSendInvitations = ref('');

    async function onPrelevementFormUpdated(onValidatePrelevementResponse?: { is_first_prelevement: boolean }) {
        if (financePrelevementsDecaissementsRef.value) {
            financePrelevementsDecaissementsRef.value.doGetDecaissementDetailsInfos();
        }
        if (financePrelevementsWalletRef.value) {
            financePrelevementsWalletRef.value.doGetWalletDetailsInfos();
        }

        if (onValidatePrelevementResponse?.is_first_prelevement == true) {
            const confirmation = await confirmationModalRef.value!.open("Prélèvements", "Le premier prélèvement a été validé avec succès. Voulez-vous envoyer les liens d'invitations aux membres de la collectivité pour qu'ils puissent accéder à leur espace personnel et valider leur souscription ?");
            if (confirmation) {
                    loadingSendInvitations.value = true;
                    try {
                    const response = await axios.post('/backoffice/collectivites/membres/send_invitations_unverified', {
                        collectivite_id: collectivite.id
                    });
                } catch(error: any) {
                    errorMessageSendInvitations.value = error.message;
                } finally {
                    loadingSendInvitations.value = false;
                }
            }
        }
    }
</script>
<template>
    <section class="container-full-1 bg-grey-50">
        <div class="page-space-40"></div>

        <h4 class="s7 font-semibold px-3 pb-5">Collectivités / Prélèvements - Décaissements <span class="text-sm text-grey-500"></span></h4>
        <div class="s13 flex-right gap-3 mt--2 mb-5 px-5">
            <!-- light2 border-none -->
            <span class="btn shadow-200 white2">Collectivités</span>
            <span class="btn shadow-200 white2">Statistiques</span>
            <span class="btn shadow-200 white2">Gérer les prélèvements</span>
            <span class="btn shadow-200 white2">Prélèvements / Décaissements</span>
        </div>


        <!--Collectivité info - Component-->
        <div class="s20 widget flex align-items-center px-1 py-5">
            <div class="s2_mobile h-100p px-7">
                <div class="rounded-100 overflow-hidden item active"><!--active-->
                    <img src="/assets/logos/logo6.svg" width="100%" />
                </div>
            </div>
            <div class="s4_mobile h-100p px-2">
                <h4 class="mb-2">{{ collectivite.nom }}</h4>
                <h3>C788PMKJ</h3>
            </div>
            <div class="s3_mobile h-100p px-2">
                <h4 class="font-normal mb-5">{{ collectivite.users_count }} membre(s)</h4>
                <span class="tag-state notif stroke">Actif</span>
            </div>
            <div class="s4_mobile h-100p px-3">
                <h4 class="font-normal" v-if="collectivite.created_at">
                    Date de création <br class="mb-2"/>
                    <b class="text-2xl">{{ formatDateFrench(collectivite.created_at) }}</b>
                </h4>
            </div>
            <div class="s7_mobile h-100p px-5">
                <!--Barre de progression - Component-->
                <div class="h-60 rounded-100 position-relative" style="width: 100%; background-color: rgba(var(--color-black-rgb), 0.1);">
                    <div class="widget-floating py-0 text-xl flex-right">Membres</div>
                    <div class="h-100p flex align-items-center justify-content-left rounded-100 text-2xl px-5 bg-pop-green" style="width: 100%;">
                        {{ collectivite.users_count }} membre(s)
                    </div>
                </div>
                <!--End Barre de progression-->
            </div>
        </div>
        <!--End Collectivité info-->
        <div class="clear-both h-20"></div>
        
        <!--Wallet - Component-->
        <FinancePrelevementsWallet :startup-infos="startup_infos" ref="financePrelevementsWalletRef" />
        <!--End Wallet -->
        <div class="clear-both h-5"></div>
        <div class="step vertical bg-grey-500 ml-auto mr-auto"></div>
        <div class="clear-both h-5"></div>


        <!--Prélèvements / Décaissements-->
        <FinancePrelevementsForm :startup-infos="startup_infos" @updated="onPrelevementFormUpdated" />
        <div class="clear-both h-5"></div>
        <div class="step vertical bg-grey-500 ml-auto mr-auto"></div>
        <div class="clear-both h-5"></div>


        <!--Prélèvements / Décaissements-->
        <FinancePrelevementsDecaissements :startup-infos="startup_infos" ref="financePrelevementsDecaissementsRef" />


        <div class="clear-both h-50"></div>

        <confirmation-modal ref="confirmationModalRef"></confirmation-modal>
    </section>
</template>